import {
  useApiInspectionsV1InspectionLoadsCreate,
  useApiInspectionsV1InspectionLoadsDestroy,
  useApiInspectionsV1InspectionLoadsPartialUpdate,
} from 'api';

export const useAssignLoadToInspection = () => {
  const { mutateAsync: createInspectionLoad } = useApiInspectionsV1InspectionLoadsCreate();
  const { mutateAsync: updateInspectionLoad } = useApiInspectionsV1InspectionLoadsPartialUpdate();
  const { mutateAsync: deleteInspectionLoad } = useApiInspectionsV1InspectionLoadsDestroy();

  const assign = (loadId: number, inspectionId: number) => {
    return createInspectionLoad({
      data: {
        inspection: inspectionId,
        trade_load: loadId,
      },
    });
  };

  const reassign = (loadId: number, inspectionId: number) => {
    return updateInspectionLoad({
      data: {
        inspection: inspectionId,
      },
      id: loadId,
    });
  };

  const unassign = (loadId: number) => {
    return deleteInspectionLoad({
      id: loadId,
    });
  };

  return { assign, reassign, unassign };
};
